import React, { Component } from 'react'
import { Row, Col, Card, Table, Button, Modal, Form, Container } from 'react-bootstrap';
import { shortFullDate } from '.././../utils/dateFormat';
import api from '../../api';
import { Formik } from 'formik';
import * as Yup from 'yup';
import { trackPromise } from 'react-promise-tracker';
import ButtonLoader from '../../components/ButtonLoader';
import { AuthContext } from '../../contexts/auth';
let transHistory;
export default class index extends Component {
    static contextType = AuthContext;

    state = {
        firstName: "",
        lastName: "",
        currentBalance: "",
        transactionHistory: [],
        transactionHistoryForSearchDate: [],
        voucherNo: "",
        voucherAmount: ""
    }

    validSchema = Yup.object().shape({
        fromDate: Yup.string().required("required"),
        toDate: Yup.string().required("required"),

    });

    setWallet = async () => {
        try {
            const res = await api.get("/wallet");
            // history.push("/")
            const wallet = res.data.data.wallet.find((wallet) => wallet.walletType == 'bw')
            this.setState({ currentBalance: wallet.totalPoints });
            console.log(res.data.data);
        }
        catch (err) {
            // setAlert2(true);
            console.log(err)
        }
    }
    setTransactionHistory = async () => {
        try {
            const res = await api.get("/sale/saleTransaction/journalEntries/buyer");
            // const wallet = res.data.data.wallet.find((wallet) => wallet.walletType == 'bw')
            this.setState({ transactionHistory: res.data.data.finaljournalEntries });
            transHistory = res.data.data.finaljournalEntries
            console.log(res.data.data);
        }
        catch (err) {
            // setAlert2(true);
            console.log(err)
        }
    }
    onSearchSubmit = async (values) => {
        // const toDate = parseInt(values.toDate[9]) + 1;
        try {
            const res = await api.post("/sale/saleTransaction/journalEntries/buyer/search", values);
            this.setState({ transactionHistory: [...res.data.data.finaljournalEntries] });
            // transHistory = res.data.data.finaljournalEntries
            // console.log(res.data.data);
        }
        catch (err) {
            // setAlert2(true);
            console.log(err)
        }
        // const splitArray = (string) => {
        //     var FF = string.split(" ");
        //     // var FFF = FF[1];
        //     console.log("FF", FF)
        //     return FF;
        // }
        // const fromDate = splitArray(shortFullDate(values.fromDate));
        // const toDate = splitArray(shortFullDate(values.toDate));

        // console.log("fandt", fromDate, toDate)

        // const seatchTransactionHistoryFromDate = transHistory.filter((history) => splitArray(shortFullDate(history.createdAt))[0] == fromDate[0] && splitArray(shortFullDate(history.createdAt))[1] >= fromDate[1] && splitArray(shortFullDate(history.createdAt))[2] == fromDate[2] && splitArray(shortFullDate(history.createdAt))[0] == toDate[0] && splitArray(shortFullDate(history.createdAt))[1] <= toDate[1] &&
        //     splitArray(shortFullDate(history.createdAt))[2] == toDate[2])

        // console.log("searchFROM", seatchTransactionHistoryFromDate)
        // this.setState({ transactionHistory: [...seatchTransactionHistoryFromDate] })
    }
    setName = async () => {
        try {
            const res = await api.get("/users/user");
            const { firstName, lastName } = res.data.data.user
            this.setState({ firstName, lastName, });
            console.log(res.data.data);
        }
        catch (err) {
            console.log(err)
        }
    }

    componentDidMount() {
        this.setName();
        console.log("context", this.context)
        this.setWallet();
        this.setTransactionHistory();
    }
    // componentDidUpdate(prevProp, prevState) {
    //     if (this.props.wallet !== prevProp.wallet) {
    //         this.setWallet();
    //     }

    render() {
        return (
            <div>
                <section className="section-wallet">
                    <Container>
                        <h3>Hi,{this.state.firstName} {this.state.lastName}</h3>
                        <div className="section-wallet__show-balance">
                            <h4 className="section-wallet__current-balance-heading">Current Balance: </h4>
                            <h5 className="section-wallet__current-balance-money">{this.state.currentBalance}</h5>
                        </div>
                    </Container>

                    {/* transaction history  */}

                    <div>
                        <Formik
                            // onSubmit={(values, formProps) => trackPromise(onSubmit(values, formProps), 'contact-us')}
                            onSubmit={this.onSearchSubmit}
                            validationSchema={this.validSchema}
                            enableReinitialize
                            initialValues={{
                                fromDate: "",
                                toDate: ""
                            }}
                        >
                            {(formik) => (
                                <Form onSubmit={formik.handleSubmit}>
                                    <Form.Row style={{ margin: "1rem" }}>
                                        <Form.Group controlId="fromDate" className="d-flex" hasValidation>
                                            <Form.Label className="form__label">From Date</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                style={{ width: "14rem", marginLeft: "1rem" }}
                                                type="date"
                                                name="fromDate"
                                                placeholder="Enter From Date"
                                                value={formik.values.fromDate}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.fromDate && !formik.errors.fromDate}
                                                isInvalid={formik.touched.fromDate && formik.errors.fromDate}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.fromDate}
                                            </Form.Control.Feedback>
                                        </Form.Group>

                                        <Form.Group controlId="toDate" className="d-flex" hasValidation>
                                            <Form.Label className="form__label" style={{ marginLeft: "10px" }}>To Date</Form.Label>
                                            <Form.Control
                                                className="p-3 rounded-0"
                                                style={{ width: "14rem", marginLeft: "1rem" }}
                                                type="date"
                                                name="toDate"
                                                placeholder="Enter To Date"
                                                value={formik.values.toDate}
                                                onChange={formik.handleChange}
                                                onBlur={formik.handleBlur}
                                                isValid={formik.touched.toDate && !formik.errors.toDate}
                                                isInvalid={formik.touched.toDate && formik.errors.toDate}
                                            />
                                            <Form.Control.Feedback type="invalid">
                                                {formik.errors.toDate}
                                            </Form.Control.Feedback>
                                        </Form.Group>
                                        <Button className="button" type="submit" style={{ height: "39px", marginLeft: "15px" }}>
                                            <ButtonLoader trackerArea="contact-us">
                                                Search
                                            </ButtonLoader>
                                        </Button>
                                    </Form.Row>
                                </Form>
                            )}
                        </Formik>

                    </div>
                    <Card className="custom-card">
                        <Card.Header>
                            <Card.Title as="h5">Transaction History</Card.Title>
                        </Card.Header>
                        <Card.Body>
                            <Table className="custom-table" responsive>
                                <thead>
                                    <tr>
                                        {/* <th >Invoice</th>
                                        <th className="text-center">Sale Amount</th> */}
                                        <th >Vendor/Transfers</th>
                                        <th >PJV #</th>
                                        <th >Cash Back Type</th>
                                        <th className="text-center">Sale Amount</th>
                                        <th className="text-center">Type</th>
                                        <th className="text-center">Transaction Type</th>
                                        <th className="text-center">Points</th>
                                        <th className="text-center">Created At</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {
                                        this.state.transactionHistory.map(transaction => (
                                            <tr key={transaction.id}>
                                                {
                                                    transaction.transaction.companyName ?
                                                        <td scope="row" > {transaction.transaction.companyName}</td>
                                                        :
                                                        <td scope="row" ></td>
                                                }
                                                <td className="text-left" > {transaction.transaction.id}</td>
                                                <td className="text-left" > {transaction.transaction.cashBackType}</td>
                                                {
                                                    transaction.transaction.voucherAmount ?
                                                        <td className="text-center"> {transaction.transaction.voucherAmount}</td>
                                                        :
                                                        <td className="text-center">0</td>
                                                }
                                                {
                                                    transaction.type == 'debit' ?
                                                        <td className="text-center"> DR</td>
                                                        :
                                                        <td className="text-center">CR</td>
                                                }
                                                <td className="text-center"> {transaction.transaction.type}</td>
                                                <td className="text-center"> {transaction.points}</td>
                                                <td className="text-center"> {shortFullDate(transaction.createdAt)}</td>
                                            </tr>
                                        ))
                                    }
                                </tbody>
                            </Table>
                        </Card.Body>
                    </Card>
                </section >
            </div >

        )
    }
}
